import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { K2IssuersEdit } from "./edit";
import { K2IssuersNew } from "./new";
import { K2IssuersTable } from "./table";

export default function K2Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K2IssuersEdit />} />
      <Route index element={<K2IssuersTable />} />
      <Route path="/new" element={<K2IssuersNew />} />
    </Routes>
  );
}
